export default __webpack_public_path__ + "static/media/demoed.69f888a8.png";